<template>
  <div class="layout-wrapper" :class="containerClass">
    <app-topbar-public :show-sidebar="false"></app-topbar-public>
    <div style="margin: 1rem 0rem; padding: 0rem 0rem;" class="layout-main-container">
      <div class="layout-main">
        <div class="main-content-card">
          <router-view></router-view>
        </div>
      </div>
      <app-footer-public></app-footer-public>
    </div>
    <div class="layout-mask animate-fadein"></div>
  </div>
</template>

<script setup>
import { useLayout } from '@/layout/composables/layout';
import { computed, ref, watch, onMounted } from 'vue';
import AppFooterPublic from './AppFooterPublic.vue';
import AppTopbarPublic from './AppTopbarPublic.vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth.store';

const { layoutConfig, layoutState, isSidebarActive } = useLayout();

const outsideClickListener = ref(null);

const router = useRouter()
const authStore = useAuthStore();

onMounted(() => {
  authStore.ensureUserIsLoggedIn();
});

const meta = computed(() => {
  return router.currentRoute.value.meta;
});

const showSidebar = computed(() => {
  if (!meta.value.showSidebar) {
    requestAnimationFrame(() => {
      const element = document.querySelector('#app > div > div > div.layout-main-container')
      if (element) element.style = 'margin-left: 0px;';
    })
  } else {
    requestAnimationFrame(() => {
      const element = document.querySelector('#app > div > div > div.layout-main-container')
      if (element) element.style = '';
    })
  }
  return !!meta.value.showSidebar;
});

watch(isSidebarActive, (newVal) => {
  if (newVal) {
    bindOutsideClickListener();
  } else {
    unbindOutsideClickListener();
  }
});

const containerClass = computed(() => {
  return {
    'layout-overlay': layoutConfig.menuMode === 'overlay',
    'layout-static': layoutConfig.menuMode === 'static',
    'layout-static-inactive': layoutState.staticMenuDesktopInactive && layoutConfig.menuMode === 'static',
    'layout-overlay-active': layoutState.overlayMenuActive,
    'layout-mobile-active': layoutState.staticMenuMobileActive
  };
});

function bindOutsideClickListener() {
  if (!outsideClickListener.value) {
    outsideClickListener.value = (event) => {
      if (isOutsideClicked(event)) {
        layoutState.overlayMenuActive = false;
        layoutState.staticMenuMobileActive = false;
        layoutState.menuHoverActive = false;
      }
    };
    document.addEventListener('click', outsideClickListener.value);
  }
}

function unbindOutsideClickListener() {
  if (outsideClickListener.value) {
    document.removeEventListener('click', outsideClickListener);
    outsideClickListener.value = null;
  }
}

function isOutsideClicked(event) {
  const sidebarEl = document.querySelector('.layout-sidebar');
  const topbarEl = document.querySelector('.layout-menu-button');

  return !(sidebarEl.isSameNode(event.target) || sidebarEl.contains(event.target) || topbarEl.isSameNode(event.target) || topbarEl.contains(event.target));
}
</script>

<style scoped>
.app-info-footer {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem 1rem;
}

.main-content-card {
  padding: 1rem;
  margin-bottom: 1rem;
  /*background: var(--surface-card);
  border-radius: 12px;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);*/

}
</style>